(function () {
  if (window.MiisBuyNowFixLoaded) return;
  window.MiisBuyNowFixLoaded = true;

  document.addEventListener(
    'click',
    function (event) {
      const bssButton = event.target.closest('.bss-b2b-btn-buyitnow');
      if (!bssButton) return;

      const paymentButton = bssButton.closest('.shopify-payment-button');
      const nativeButton = paymentButton && paymentButton.querySelector('[bss-b2b-default-buy-now="true"]');
      if (!nativeButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      nativeButton.click();
    },
    true
  );
})();
